<template>
<div class="card card-plain">
    <div role="tab" id="headingOne" class="card-header">
        <a data-toggle="collapse" data-parent="#accordion" :href="`#${itemId}`" @click.prevent="activate" :aria-expanded="active" :aria-controls="`content-${itemId}`">
            <slot name="title">  
                    {{ title }}      
            </slot>
            <i class="tim-icons icon-minimal-down" style="color: black;"></i>
            <slot name="status">
                <span style="float: right; position: relative; margin-right:15px" :class="{'text_danger': !completed, 'text_success': completed }">
                    {{ completed ? "COMPLETE" : "NOT COMPLETE" }}
                </span>
            </slot>

        </a>
    </div>
    <collapse-transition :duration="animationDuration">
        <div v-show="active" :id="`content-${itemId}`" role="tabpanel" :aria-labelledby="title" class="collapsed">
            <div class="card-body">
                <div v-show="tooltip" style="float:right !important" > 
                    <el-tooltip
                    :content=tooltip
                    :open-delay="300"
                    effect="light"
                    placement="top"
                    trigger="click"
                  >
                  <i style="padding-left: 10px;" class="tim-icons icon-alert-circle-exc"></i>
                  </el-tooltip>
                </div>
                <slot></slot>
            </div>
        </div>
    </collapse-transition>
</div>
</template>

<script>
import {
    CollapseTransition
} from 'vue2-transitions';

export default {
    name: 'collapse-form-item',
    components: {
        CollapseTransition
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        tooltip: {
            type: String,
            default: ''
        },
        tooltipShow: {
            type: String,
            default: "false"
        },
        status: [Boolean, Array],
        id: String,
        tabChange: {
            type: Boolean,
            defaut: false
        }
    },
    inject: {
        animationDuration: {
            default: 250
        },
        multipleActive: {
            default: false
        },
        addItem: {
            default: () => {}
        },
        removeItem: {
            default: () => {}
        },
        deactivateAll: {
            default: () => {}
        }
    },
    computed: {
        itemId() {
            return this.id || this.title;
        },
        completed: function () {
            return this.status;
        }
    },
    data() {
        return {
            active: false,
            SUBMIT_PREORDER: 'This is a tool tip for submit preorder',
    
        };
    },
    methods: {
        activate() {
            let wasActive = this.active;
            if (!this.multipleActive) {
                this.deactivateAll();
            }
            this.active = !wasActive;

            // load items when it opens, not need to load on both closing and open
            if(this.active)
                this.$emit('tabOpen', this.itemId, this.active);
        }
    },
    watch: {
        // if the current is true, the watch will get the previous state instead of the current one
        // so using !after
        // if we use if(after), the page will reload when user moves away from the current phase,
        // if we use if(!after), the page will reload when user lands on the the current phase
        tabChange(after, pre) {
            if(after) {
                this.deactivateAll();
                this.$emit('moveAway');
            }
        }
    },
    mounted() {
        this.addItem(this);
    },
    destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        this.removeItem(this);
    }
};
</script>

<style>
.text_success {
    color: #275d34;
}

.text_danger {
    color: #e12f2f;
}
</style>
